// src/components/first_screen/EventDisplay.jsx
import { MapPin } from "lucide-react";

// Works for both CRA (.env REACT_APP_*) and Vite (.env VITE_*)
const BASE_IMAGE_URL =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_IMAGE_BASE_URL) ||
  process.env.REACT_APP_IMAGE_BASE_URL ||
  "https://cdn.connectummah.com/myuploadfiles/";

function toAbsoluteUrl(link) {
  if (!link) return null;

  // Already absolute
  if (/^https?:\/\//i.test(link)) return link;

  // Ensure exactly one slash between base + path
  const base = String(BASE_IMAGE_URL).replace(/\/+$/, "");
  const path = String(link).replace(/^\/+/, "");
  return `${base}/${path}`;
}

const EventDisplay = ({ event, parent_Id }) => {
  const cardWrapperClass = `relative overflow-hidden block sm:flex sm:justify-center sm:items-center ${
    parent_Id === null ? "h-[100svh]" : "sm:h-[70svh]"
  }`;

  const imageClass = `h-full w-full p-2 ${parent_Id === null ? "object-contain sm:object-cover" : "object-cover"
    }`;

  if (!event) {
    return <div className={cardWrapperClass}>No Event Data</div>;
  }

  const {
    name,
    description,
    location,
    masjid_Name,
    city_Name,
    state_Name,
    country_Name,
    images,
  } = event;

  // ✅ Always normalize to absolute URL
  const imageUrl =
    toAbsoluteUrl(images?.[0]?.imageLink) ||
    toAbsoluteUrl(images?.[0]) ||
    toAbsoluteUrl(event?.imageUrl) ||
    toAbsoluteUrl(event?.masjid?.imageLink) ||
    null;

  return (
    <div className={cardWrapperClass}>
      {/* Image or Fallback Info */}
      {imageUrl ? (
        <img src={imageUrl} alt={name || "Event"} className={imageClass} />
      ) : (
        <div className="text-center px-4">
          <h2 className="text-gray-900 text-[6svh] font-bold mb-2">
            {name || "Unnamed Event"}
          </h2>

          {description && (
            <p className="text-gray-600 text-[3svh] mb-4 italic">
              {description}
            </p>
          )}

          <div className="flex flex-col items-center gap-1 text-gray-700 text-[1svh]">
            {(location || masjid_Name || city_Name || state_Name || country_Name) && (
              <>
                <div className="flex items-center gap-1 font-medium text-[2.5svh]">
                  <MapPin className="text-blue-600 w-[2.5svh] h-auto" />
                  <span>{location || "Location not specified"}</span>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Bottom info overlay (with gradient for readability) */}
      <div className="absolute bottom-0 w-full">
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-white/90 to-transparent" />

        <div className="relative w-full flex flex-wrap items-end pb-2">
          <div className="w-1/2 px-3 font-semibold text-[1.5svh] sm:text-[2svh] text-gray-800">
            {masjid_Name || "Unknown Masjid"}
          </div>

          <div className="w-1/2 flex justify-end items-center gap-1 px-2 text-gray-600">
            <MapPin className="text-blue-600 w-[2.1svh] h-auto" />
            <span className="text-[1.3svh] sm:text-[1.8svh]">
              {[city_Name, state_Name, country_Name].filter(Boolean).join(", ")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDisplay;
